<template>
  <div class="room">
    <VideoRoomErrorPage v-if="roomError" />
    <VideoRoomClosed v-else-if="closed" />
    <VideoRoomEnter v-else />
  </div>
</template>

<script>
import useRoom from '@/compositions/useRoom';
import VideoRoomEnter from '@/components/VideoRoomEnter.vue';
import VideoRoomClosed from '@/components/VideoRoomClosed.vue';
import VideoRoomErrorPage from '@/components/VideoRoomErrorPage.vue';

export default {
  components: {
    VideoRoomErrorPage,
    VideoRoomClosed,
    VideoRoomEnter,
  },
  setup(props, context) {
    const {
      closed, setupDone, error,
    } = useRoom(context);

    setupDone.value = true;

    return {
      closed,
      roomError: error,
    };
  },
};
</script>

<style lang="scss" scoped>
.room {
  background: #F3F3F3;
  height: 100vh;
}
.fullscreen-exit {
  position: absolute;
  top: 50%;
}

.main-video {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  display: flex;
  align-items: center;
  align-content: center;
  background: #000;
}

.start-publish {
  align-self: center;
  width: 300px;
  position: absolute;
  background: #ccc;
  left: 50%;
  margin-left: -150px;
  padding: 1rem;
  z-index: 3;
}

.main-video video {
  margin: 0 auto;
  max-height: 100%;
  max-width: 100%;
  height: 100%;
}
.video-room-card {
  max-width: 37.5rem;
  padding: 1.875rem 3.125rem 2.625rem;
  background: #FFFFFF;
  box-shadow: 0 2px 0.5rem rgba(0, 0, 0, 0.15);
  border-radius: 0.5rem;
  text-align: left;
  margin: 1.875rem auto;
}
.video-room {
  background: #3A3A3C;
  font-size: 0.875rem;
  line-height: 1.43;
  color: #E0E0E0;
  &__wrap {
    display: flex;
    justify-content: space-between;
    height: 100vh;
  }
  &__left-wrap {
    width: 100%;
  }
}
@media (max-width: 599px) {
  .video-room-card {
    padding: 1.875rem 1.875rem 2.5rem;
  }
}
</style>
